export default {
      id: "general_warning-usage",
      viewBox: "0 0 50 50",
      url: "/" + "images/icons.3.109.2.svg#general_warning-usage",
      toString: function () {
        return this.url;
      }
    }